import { render, staticRenderFns } from "./GroupAdministrators.vue?vue&type=template&id=7fde0e21&scoped=true"
import script from "./GroupAdministrators.vue?vue&type=script&lang=js"
export * from "./GroupAdministrators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde0e21",
  null
  
)

export default component.exports